import { useCallback, useEffect } from 'react';
import {
  FormSubmitServiceToken,
  type IFormSubmitService,
} from 'src/services/FormSubmitService';
import {
  PasswordService,
  PasswordServiceToken,
} from 'src/services/PasswordService';
import { ServicesProvider } from 'src/services/ServicesProvider';
import { type LoginServerState, useApplicationServerContext } from 'src/state';
type SmdSubmitProps = {
  onPhonenumber: (phonenumber: string) => void;
  onSubmitting: (isSubmitting: boolean) => void;
  xsrf: string;
};
export function useSmsSubmit({
  onPhonenumber,
  onSubmitting,
  xsrf,
}: SmdSubmitProps) {
  const [serverState] = useApplicationServerContext() as [LoginServerState];
  const formSubmitService = ServicesProvider.getSingleton<IFormSubmitService>(
    FormSubmitServiceToken,
  );
  useEffect(() => {
    const controller = new AbortController();
    async function fetchSmsData() {
      const passwordService =
        ServicesProvider.getSingleton<PasswordService>(PasswordServiceToken);
      // Fetch phonenumber to display after user/pass submit
      const phoneNumberResponse = await passwordService.getSmsData(
        xsrf,
        serverState.forms.sms.fields.traceparent.value ?? '',
        controller.signal,
      );

      if (phoneNumberResponse.status === 200) {
        const { data: phoneNumberData }: { data: { phoneNumber: string } } =
          await phoneNumberResponse.json();
        // Store phonenumber in state
        onPhonenumber(phoneNumberData.phoneNumber);
      }
    }
    fetchSmsData();
    return () => {
      controller.abort();
    };
  }, [onPhonenumber, serverState.forms.sms.fields.traceparent.value, xsrf]);

  const postSmsForm = useCallback(
    (form: HTMLFormElement) => {
      formSubmitService.submitForm(form);
      onSubmitting(true);
    },
    [formSubmitService, onSubmitting],
  );
  return { postSmsForm };
}
